<template>
    <div class="modal fade" id="site-added"  data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog"
         aria-labelledby="editRecord" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" v-if="!showVideoModal">
                <div class="modal-header">
                    <h5 class="modal-title d-inline">One step away to add your domain {{domainName}}</h5>
                </div>
                <form @submit.prevent="submit_respose">
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-12">
                          <div class="alert alert-danger">
                            <span>
                              <strong> Alert - </strong>
                              <span>
                                You are one step away to add your domain. Please click {{ (registeredWithUs) ? 'submit' : 'proceed' }} to finish the domain installation request.
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                        <p class="text-info">Your domain request has been received! We are configuring it now and will let you know once completed.</p>
                        <p class="text-info">The next step is changing your nameservers in order to allow your domain to load your website here at BigScoots.</p>
                        <hr>
                        <p>Below are the nameservers which need to be changed at your domain registrar</p>
                        <ul class="list-unstyled">
                            <li class="text-info">
                               {{cloudflare.nameserver1}}
                            </li>
                            <li class="text-info">
                               {{cloudflare.nameserver2}}
                            </li>
                        </ul>

                        <div class="form-group">
                            <!--													<span class=" mr-4"><strong>{{ domainName }}</strong></span>-->
                            <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : registeredWithUs, 'bootstrap-switch-off bootstrap-switch-focused' : !registeredWithUs }">
                                <div class="bootstrap-switch-container" @click="registeredWithUs = !registeredWithUs">
                                    <span class="bootstrap-switch-handle-on bootstrap-switch-primary">Yes</span>
                                    <span class="bootstrap-switch-label"></span>
                                    <span class="bootstrap-switch-handle-off bootstrap-switch-default">No</span>
                                </div>
                            </div>
                            <label  class="ml-1" style="font-size: 11px;">
                                <b>Do you need help?</b> If you are unsure or would prefer not to do this yourself, we'd be happy to do it for you.
                            </label>
                        </div>
                        <section class="mt-3" v-if="registeredWithUs" >
                            <div class="form-row">
                                <div v-if="domainRegistrar.accessGranted" class="col-md-12 ">
                                    <button class="btn btn-default btn-round btn-sm d-block pull-right" @click="resetHostFields()">
                                        Reset Host Fields
                                    </button>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="validationCustom01">Name of Current Domain Registrar <strong class="text-danger">*</strong></label>
                                    <select @change="checkIfBigScoots()" v-model="domainRegistrar.name" required="required" class="form-control" id="validationCustom01" style="padding-bottom: 5px">
                                        <option v-for="host in commonHosts" :value="host" :key="host">{{host}}</option>
                                    </select>
                                    <!--															<input v-model="domainRegistrar.name" required="required" type="text" class="form-control" id="validationCustom01" placeholder="Example: GoDaddy">-->
                                </div>

                                <div class="col-md-6" v-if="domainRegistrar.showAccessBtn">
                                    <button class="btn btn-primary btn-round d-block mt-4"
                                            @click.prevent="showVideoModal = true">
                                        Give BigScoots Access
                                    </button>
                                </div>
                                <div class="col-md-6 mb-3" v-if="!domainRegistrar.showAccessBtn">
                                    <label for="validationCustom02">Domain Panel Web Address <strong class="text-danger">*</strong></label>
                                    <input :disabled="isBigScoots || domainRegistrar.webAddress === 'Access granted'" v-model="domainRegistrar.webAddress" required="required" type="text" class="form-control" id="validationCustom02" placeholder="Example: https://www.godaddy.com">
                                </div>
                            </div>
                            <div class="form-row" v-if="!domainRegistrar.showAccessBtn">
                                <div class="col-md-6 mb-3">
                                    <label for="validationCustom03">Domain Panel Username <strong class="text-danger">*</strong></label>
                                    <input :disabled="isBigScoots || domainRegistrar.username === 'Access granted'" v-model="domainRegistrar.username" required="required" type="text" class="form-control" id="validationCustom03">
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="validationCustom04">Domain Panel Password <strong class="text-danger">*</strong></label>
                                    <input :disabled="isBigScoots || domainRegistrar.password === 'Access granted'" v-model="domainRegistrar.password" required="required" type="text" class="form-control" id="validationCustom04">
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12 mb-3">
                                    <label for="validationCustom05">Any Other Special Instructions?</label>
                                    <textarea :disabled="isBigScoots" type="text" v-model="domainRegistrar.instructions" class="form-control" id="validationCustom05"></textarea>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="modal-footer">
                        <div style="width: 20%" v-if="proceeding" class="loading-dots text-danger pull-right">Please wait</div>
                        <button type="submit" v-if="registeredWithUs" :disabled="checkButtonDisability || proceeding" class="btn btn-outline-primary btn-round btn-sm pull-right">
                            <div class="loader small_loader" v-if="proceeding"></div>
                            <span v-else>
                                Submit
                            </span>
                        </button>
                        <button type="submit" v-else class="btn btn-outline-primary btn-round btn-sm pull-right" :disabled="proceeding">
                            <div class="loader small_loader" v-if="proceeding"></div>
                            <span v-else>
                                Proceed
                            </span>
                        </button>
                    </div>
                </form>
            </div>
            <div v-else class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Give BigScoots Access!</h5>
                </div>
                <div class="modal-body" v-if="!denied">
                    <div class="row">
                        <div class="col-md-12">
                            <iframe v-if="domainRegistrar.name === 'GoDaddy'" class="w-100" height="350" src="https://www.youtube.com/embed/_gnGX8SwoaU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <iframe v-else class="w-100" height="350"  src="https://www.youtube.com/embed/ovPDNYxWTNc" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <div class="row">
                                <div class="col-12">
                                    <p class="text-center text-danger mt-4" style="font-size: 1.2rem;">
                                        <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                                        <strong>When delegating access to BigScoots in your {{ domainRegistrar.name }} account, please be sure to use staff@bigscoots.com</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <button type="button" class="btn btn-danger" @click="grantDenyAccess(true, false, false, '', '', '', null)">Unable to grant access</button>
                            <button type="button" class="btn btn-success" @click="grantDenyAccess(false, true, false, 'Access granted', 'Access granted', 'Access granted', false)">Successfully granted access!</button>
                        </div>
                    </div>
                </div>
                <div v-else class="modal-body">
                    <p>
                        That's okay, please provide us with your login details and we'll take care of it for you.
                    </p>
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <button type="button" class="btn btn-secondary" @click="showVideoModal = false">Proceed</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import swal from "sweetalert2";
    import {db, functions} from "@/firebase/init";
    export default {
        name: "AddSitesSuccess",
        props: {
            keyword:{
                type: String,
                required: true
            },
            domainName:{
                type: String,
                required: true
            },
            cloudflare: {
                type: Object,
                required: true
            },
            isPrimaryExist: {
                type: Boolean,
                required: true
            },
            installationType: {
                type: String,
                required: true
            },
            isCollaboration: {
                type: Boolean,
                required: false,
                default: false
            },
            supervisor: {
                type: Object,
                required: false
            },
            domainTicketId: {
                type: String,
                required: false
            }
        },
        computed: {
            checkButtonDisability (){
                if(this.domainRegistrar.name === 'BigScoots') { return false; }
                return this.domainRegistrar.name === '' || this.domainRegistrar.password === ''
                    || this.domainRegistrar.username === '' || this.domainRegistrar.webAddress === '';

            },
            clientID() {
                return this.$store.getters.getRequestCustomerID;
            },
            user() {
                return this.$store.getters.user;
            },
            userToken() {
                return this.$store.getters.getUserToken;
            },
            userUID() {
                return this.$store.getters.getUID;
            }
        },
        data(){
            return{
                isBigScoots: false,
                proceeding:false,
                registeredWithUs:false,
                domainRegistrar: {
                    name: '',
                    webAddress: '',
                    username: '',
                    password: '',
                    instructions:'',
                    showAccessBtn: false,
                    accessGranted: false,
                },
                commonHosts: [
                    'BigScoots',
                    'WPOPT',
                    'OrangeGeek',
                    'WP Engine',
                    'FlyWheel',
                    'BlueHost',
                    'HostGator',
                    'GoDaddy',
                    'Kinsta',
                    'SiteGround',
                    'Other'
                ],
                showVideoModal: false,
                denied: false
            }
        },
        methods:{
            grantDenyAccess(denied, accessGranted, showAccessBtn, password, username, webAddress, showVideoModal) {
                this.denied = denied
                this.domainRegistrar.accessGranted = accessGranted
                this.domainRegistrar.showAccessBtn = showAccessBtn
                this.domainRegistrar.password = password;
                this.domainRegistrar.username = username;
                this.domainRegistrar.webAddress = webAddress;
                if (showVideoModal !== null) {
                    this.showVideoModal = showVideoModal
                }
            },
            resetHostFields () {
                this.denied = false
                this.domainRegistrar.accessGranted = false
                this.domainRegistrar.password = '';
                this.domainRegistrar.username = '';
                this.domainRegistrar.webAddress = '';
                this.domainRegistrar.name = '';
            },
            changedHost (value) {
                this.denied = false
                this.domainRegistrar.accessGranted = false
                this.domainRegistrar.password = '';
                this.domainRegistrar.username = '';
                this.domainRegistrar.webAddress = '';
                if (value === 'GoDaddy' || value === 'SiteGround') {
                    this.domainRegistrar.showAccessBtn = true
                } else {
                    this.domainRegistrar.showAccessBtn = false
                }
            },
            close_modal(){
                $('#site-added').modal('hide');
                this.$router.push({name: 'siteDetails'})
            },
            checkIfBigScoots () {
              this.isBigScoots = this.domainRegistrar.name === 'BigScoots';
              this.changedHost(this.domainRegistrar.name)
            },
            submit_respose() {
                this.proceeding = true;
                const key = (this.registeredWithUs) ? 'submit (' + this.domainRegistrar.username + ')' : 'ok'
                this.addLog({
                  message: `User has been responded as ${key} to the name server popup, Domain: ${this.domainName}`,
                  level: 'info'
                });
                const addNewAddonDomain = functions.httpsCallable("addDomainRegistrarTicket");
                addNewAddonDomain({
                    clientID: this.clientID,
                    addonDomain: this.domainName,
                    registrar: (this.registeredWithUs) ? this.domainRegistrar : 'null',
                    email: (this.isCollaboration) ? this.supervisor.supervisorEmail : this.user.email,
                    domainType: (this.isPrimaryExist) ? 'Add-On' : 'Primary',
                    installationType: (this.installationType === 'freash') ? 'fresh' : this.installationType,
                    nameservers: {
                        one: this.cloudflare.nameserver1,
                        two: this.cloudflare.nameserver2
                    },
                    domainTicketId: this.domainTicketId
                }).then(async result => {
                    if (result.data.success === true) {
                        await db.collection('supportTaskTrack').doc(this.domainName).update({
                          supportTaskCreated: true,
                          description: 'Nameservers have been generated automatically',
                        });
                        this.proceeding = false;
                        this.close_modal();
                        if(this.isCollaboration) {
                            window.location.reload();
                            return;
                        }
                        swal({
                            title: this.domainName + " has been " + this.keyword + " successfully",
                            text: 'Your domain request has been received! We are configuring it now. Expect an update via ticket and email in a few moments.\n', // result.data.message,
                            type: "success",
                            confirmButtonText: (!this.isCollaboration) ? "Go Back to Sites Page" : 'OK!',
                            confirmButtonColor: "#6ACF98"
                        }).then(result => {
                            if (result.value) {
                                this.$router.push({name: 'siteDetails'});
                            }
                        });
                    } else {
                        await db.collection('supportTaskTrack').doc(this.domainName).update({
                          description: 'Not Success addDomainRegistrarTicket cloud function',
                        });
                        this.proceeding = false;
                        swal({
                            title: "Some problem has happened!",
                            text: result.data.message,
                            type: "error",
                            confirmButtonText: "OK",
                            confirmButtonColor: "#6ACF98"
                        });
                    }
                }).catch(async err => {
                        await db.collection('supportTaskTrack').doc(this.domainName).update({
                          description: 'Error in addDomainRegistrarTicket cloud function',
                        });
                        this.proceeding = false;
                        swal({
                            title: "Some problem has happened!",
                            text: err.message,
                            type: "error",
                            confirmButtonText: "OK",
                            confirmButtonColor: "#6ACF98"
                        });
                    });
            }
        }
    }
</script>

<style scoped>

</style>
